import React from 'react';
import PropTypes from 'prop-types';
import { InformacoesDemonstrativo, Label, Description, Value } from './styles';

const formatDate = (dateString) => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return date.toLocaleDateString('pt-BR');
};

function CooperatorInfo({ cooperator }) {
  return (
    <InformacoesDemonstrativo>
      <Label>
        <Description>Nome do Cooperado</Description>
        <Value>{cooperator.nomeCooperado || '-'}</Value>
      </Label>
      <Label>
        <Description>Matrícula</Description>
        <Value>{cooperator.matricula || '-'}</Value>
      </Label>
      <Label>
        <Description>Atividade</Description>
        <Value>{cooperator.atividade || '-'}</Value>
      </Label>
      <Label>
        <Description className="center-align">Qtde Dep IR</Description>
        <Value className="center-align">{cooperator.quantidadeDependentes ?? '-'}</Value>
      </Label>
      <Label>
        <Description className="center-align">Associação</Description>
        <Value className="center-align">{formatDate(cooperator.dataAssociacao)}</Value>
      </Label>
      <Label>
        <Description className="center-align">FL</Description>
        <Value className="center-align">{cooperator.fl || '-'}</Value>
      </Label>
    </InformacoesDemonstrativo>
  );
}

CooperatorInfo.propTypes = {
  cooperator: PropTypes.shape({
    nomeCooperado: PropTypes.string,
    matricula: PropTypes.string,
    atividade: PropTypes.string,
    quantidadeDependentes: PropTypes.number,
    dataAssociacao: PropTypes.string,
    fl: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
};

export default CooperatorInfo;
